import { FiChevronDown } from 'react-icons/fi';

export const PopoverIcon = (props) => {
  const iconStyles = {
    transform: props.isOpen ? 'rotate(-180deg)' : undefined,
    transition: 'transform 0.2s',
    transformOrigin: 'center',
    display: 'inline-flex',
    verticalAlign: 'middle',
  };
  return <FiChevronDown aria-hidden style={iconStyles} />;
};
